var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"learnSort"},[_vm._t("sortImg"),_c('div',{staticClass:"sortText"},[_vm._t("sortText")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }